import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * SimpleBooking
 *
 * **Important**: this engine must use script version 3.9
 * because they install the script with SRI attributes.
 * If there is a need to upgrade the script to newer versions,
 * then the IBE must be notified.
 *
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_170
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      // Gatto Bianco (PID: 1030614)
      if (window.location.hostname.match(/www\.gattobianco-capri\.com/)) {

        const auxLang = window.searchBox && thn.objectGet(window.searchBox, 'CodLang')?.toLowerCase();

        if (auxLang && ctx.langs.test(auxLang)) {
          resolve(auxLang);
          return;
        }
      }

      let lang = document.querySelector('.current-language-item');

      if (lang) { lang = lang.innerHTML; }

      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      lang = thn.parseUrlParameter('lang');

      if (lang && lang.length) { lang = lang.toLowerCase(); }
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      lang = ctx.getHtmlLang({ attributes: ['xml:lang', 'hreflang', 'lang'] });

      if (lang === 'cn') {
        lang = 'zh';
      } else if (lang === 'az') {
        lang = 'en';
      }

      if (ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      reject('no_language');

    });
  };

  /**
     * @memberOf module:bs_170
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {

    const promoInput = window.document.querySelector('.sb-coupon-code');

    if (promoInput) {
      ctx.promocode = promoInput.value;
    }

    return ctx.promocode;
  };

  /**
     * @memberOf module:bs_170
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://simplebooking.stararctichotel.com/ibe/hotelbooking/search?hid=5514&lang=EN&_gl=1*10im63n*_ga*MjA1Nzk1NDE4NC4xNzAwMTQ5OTAz*_up*MQ..#q&guests=A,A&in=2023-11-19&out=2023-11-20&coupon=
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.includes('simplebooking');

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
     * @memberOf module:bs_170
     * @see {@link onHashChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onHashChange = function onHashChange(ctx) {
    setTimeout(thn.pageCheck, 500);
  };

  /**
     * @memberOf module:bs_170
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = thn.debounce(() => {
    thn.pageCheck({ force: thn.widgets.price.isTargetPage() });
  }, 600);

  /**
     * @memberOf module:bs_170
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const searchButton = document.querySelector('.sb-do-search-cmd');
    const loader = document.querySelector('#loader-indicator');
    const container = document.querySelector('.sb-results-view');
    let spinner;

    if (loader && !thn.simplebookingLoaderObserver) {
      thn.simplebookingLoaderObserver = thn.debounce(function thnSimplebookingLoaderObserver() {
        spinner = document.querySelector('.spinner');
        if (!spinner) {
          setTimeout(function () {
            thn.languageCheck().then(function ({ changed }) {
              if (!changed && ctx.widget.refresh() && !ctx.widget.isSet()) {
                ctx.widget.hide();
              }
            });
          }, 1000);
        }
      }, 200);

      thn.observeDom(loader, thn.simplebookingLoaderObserver, {
        childList: true,
        subtree: true,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(loader, thn.simplebookingLoaderObserver);
        delete thn.simplebookingLoaderObserver;
      });
    }

    if (searchButton && !thn.simplebookingUpdate) {
      thn.simplebookingUpdate = thn.debounce(function thnSimplebookingUpdate() {
        if (!searchButton.disabled) {
          setTimeout(function () {
            thn.languageCheck().then(function ({ changed }) {
              if (!changed && ctx.widget.refresh() && !ctx.widget.isSet()) {
                ctx.widget.hide();
              }
            });
          }, 1000);
        }
      }, 200);

      thn.observeDom(searchButton, thn.simplebookingUpdate, {
        childList: false,
        subtree: false,
        characterData: false,
        attributes: true,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(searchButton, thn.simplebookingUpdate);
        delete thn.simplebookingUpdate;
      });
    }

    if (container && !thn.simplebookingPriceChangeObserve) {
      // Price elements can be re-updated even after loaded, make sure we get the latest value.
      thn.simplebookingPriceChangeObserve = thn.debounce(function (mutations) {
        if ([...mutations].some((el) => el.target.classList.contains('sb-room-container') || el.target.classList.contains('sale-price-big'))) {
          ctx.widget.update();
        }
      }, 1000);

      thn.observeDom(container, thn.simplebookingPriceChangeObserve, {
        childList: true,
        subtree: true,
        attributes: false,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(container, thn.simplebookingPriceChangeObserve);
        delete thn.simplebookingPriceChangeObserve;
      });
    }

    const undelegateClickSearch = thn.delegate('click', '#sb-syncro-container_sb__form-field--checkavailability', () => {
      setTimeout(() => thn.widgets.price.refresh(), 1000);
    });

    thn.pageUnload(() => {
      undelegateClickSearch();
    });

    const containerTopPrices = document.querySelector('.sb-results-view');

    if (containerTopPrices) {
      let refreshPriceByTop = thn.debounce(() => ctx.widget.refresh(), 600);

      thn.observeDom(containerTopPrices, refreshPriceByTop, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.pageUnload(() => {
        refreshPriceByTop.cancel();
        thn.stopObserveDom(containerTopPrices, refreshPriceByTop);
        refreshPriceByTop = null;
      });
    }
  };

  /**
     * @memberOf module:bs_170
     * @see {@link boot}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const container = document.documentElement;
    const isNewVersion = window.location.pathname.match(/ibe2/);

    if (container && isNewVersion) {
      const simpleBookingNewVersionObserver = function paradoresObserver(mutations) {
        const validMutationsRefresh = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target && mutation.target.className && mutation.target.className.match(/RateMatch/))
          .filter((mapResult) => !thn.empty(mapResult)); // mutation of R&R;
        const validMutationsRefreshMultiRoom = [...mutations].map((mutation) => mutation.type === 'childList' && mutation.target && mutation.target.nodeName && mutation.target.nodeName.match(/TITLE/))
          .filter((mapResult) => !thn.empty(mapResult));
        if (validMutationsRefresh.length || (validMutationsRefreshMultiRoom.length && document.querySelectorAll('.RoomAllocationInput').length > 1)) {
          setTimeout(() => thn.widgets.price.refresh(), 1000);
        }
      };

      thn.observeDom(container, simpleBookingNewVersionObserver, {
        childList: true,
      });

      thn.shutdown(() => {
        simpleBookingNewVersionObserver.cancel();
        thn.stopObserveDom(container, simpleBookingNewVersionObserver);
      });
    }

    const undelegate = thn.delegate('click', '.currency', () => {
      setTimeout(() => thn.widgets.price.refresh(), 1000);
    });

    thn.shutdown(() => {
      undelegate();
    });
  };

  /**
     * @memberOf module:bs_170
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {

    const widgetData = {};

    // Sometimes the prices changes when this loader is active
    const pricesLoading = !!document.querySelector('.sb-rm__loading');
    if (pricesLoading) {
      return widgetData;
    }

    // Dates
    const nightsSelector = document.querySelectorAll('.sb-nights-selection span.count');
    const newNightsSelector = [...document.querySelectorAll('title')]?.find(el => el?.textContent?.includes('moon'))?.closest('div')?.nextSibling;
    const nights = (!thn.empty(nightsSelector) && thn.parseNumber(nightsSelector[0]?.textContent)) || thn.parseNumber(document.querySelector('div.sb-info-dates > span.sb-info-dates__nights')?.textContent || newNightsSelector?.textContent);

    const dateBegin = document.querySelector('.checkin-display')?.textContent?.replace(/^\s+|\s+$|\s+(?=\s)/g, '') || document.querySelector('div.sb-info-dates > span.sb-info-dates__arrival')?.textContent;
    const dateEnd = document.querySelector('.checkout-display')?.textContent?.replace(/^\s+|\s+$|\s+(?=\s)/g, '') || document.querySelector('div.sb-info-dates > span.sb-info-dates__departure')?.textContent;

    widgetData.dateBegin = thn.dateToString(thn.parseUrlParameter('in')) || translateDate(dateBegin, thn.data.language);
    widgetData.dateEnd = thn.dateToString(thn.parseUrlParameter('out')) || translateDate(dateEnd, thn.data.language);

    // Guests
    const adults = [...document.querySelectorAll('.sb-adults-value')].reduce((a, b) => a + thn.parseNumber(b.textContent), 0);
    const children = [...document.querySelectorAll('.sb-children-value')].reduce((a, b) => a + thn.parseNumber(b.textContent), 0);

    widgetData.adults = adults
      || thn.parseNumber(document.querySelector('#sb-syncro-container_sb__form-field--guests .sb__form-field-date-number')?.textContent)
      || thn.parseNumber(document.querySelector('div.sb__guests-adults')?.textContent)
      || 2;
    widgetData.children = children || thn.parseNumber(document.querySelector('div.sb__guests-children')?.textContent) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // No availability
    const noAvailability = !!document.querySelector('.notification-warning .notification-alternative-solutions, .sb-noresult-container.sb-item-container');

    if (noAvailability) {
      widgetData.noRooms = true;
      return widgetData;
    }

    // Price and currency
    let price;
    const roomsPrice = document.querySelectorAll('.offer-price-big, .sb-room-card, .RoomOption .mainAmount>span');
    const prices = [];

    if (!thn.empty(roomsPrice)) {
      roomsPrice.forEach((e) => {
        const priceInt = (e.querySelector('.sb-int-part') ?? e)?.textContent || '';
        const priceDec = e.querySelector('.sb-dec-part')?.textContent || '';
        price = thn.parseNumber(priceInt + priceDec);

        if (!price) {
          return;
        }

        prices.push(price);
      });

      const currency = document.querySelector('.sb-room-card__price-container .sale-price-big .sb-int-part, .sb-room-card__price-container .offer-price-big .sb-int-part, .RoomOption .mainAmount>span')?.textContent || document.querySelector('.sb-currency-row.active');
      widgetData.currency = thn.parseCurrency(currency);

      const isPriceSpecial = thn.parseUrlParameter('pkgId');

      if (isPriceSpecial) {
        widgetData.priceSpecial = 1;
      }

      if (!thn.empty(prices)) {
        widgetData.price = Math.min(...prices) / nights;
        widgetData.set = true;
      }
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_170
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v2 = function priceParseData_v2(ctx) {
    const widgetData = {};

    function parseRooms(data) {
      const parsedData = [];

      data.forEach((room) => {
        const roomInfo = room.split(',');
        let adults = 0;
        let children = 0;
        const childrenAges = [];

        roomInfo.forEach((item) => {
          if (item === 'A') {
            adults += 1;
          } else if (!Number.isNaN(thn.parseNumber(item))) {
            children += 1;
            childrenAges.push(thn.parseNumber(item) === 0 ? 1 : thn.parseNumber(item));
          }
        });

        parsedData.push({ adults, children, childrenAges });
      });

      return parsedData;
    }

    function getLowestPrice(guest, rates) {
      const roomForGuests = rates.filter((item) => item.guests.adults === guest.adults && item.guests.children === guest.children);
      const prices = roomForGuests.map((rate) => rate.price).filter(Boolean);
      const lowestPrice = !thn.empty(prices) && Math.min(...prices);
      return lowestPrice;
    }

    // Dates
    let nights;
    const dateBegin = thn.parseUrlParameter('in');
    const dateEnd = thn.parseUrlParameter('out');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/-/g, '/');
      widgetData.dateEnd = dateEnd.replace(/-/g, '/');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Rooms
    const guestsPerRoom = thn.parseUrlParameter('guests')?.split('|');
    widgetData.roomsDispo = [];
    widgetData.rooms = guestsPerRoom?.length || 1;

    // Guests
    const roomsInfo = parseRooms(guestsPerRoom);
    const isMobile = thn.data.media.name === 'mobile';
    const ratesSelector = isMobile ? '.RateWithOptions > div:not(.Rate) > div > div:nth-child(1):not(.Prices)' : '.RoomOption';

    widgetData.roomsDispo = roomsInfo;

    const rates = [...document.querySelectorAll(ratesSelector)].map((el) => {
      const guestIcons = isMobile ? Array.from(el.childNodes).filter((node) => node.nodeName !== 'SPAN') : el.querySelector('div').childNodes;
      const adultIcons = guestIcons[0]?.textContent || guestIcons[0].querySelectorAll('svg').length;
      const childrenIconText = guestIcons[1]?.querySelector('div > p')?.textContent;
      const childrenIcons = (!childrenIconText?.includes('(') && childrenIconText) || guestIcons[1]?.querySelectorAll('svg').length || 0;
      const guests = widgetData.rooms > 1 ? { adults: thn.parseNumber(adultIcons), children: thn.parseNumber(childrenIcons) } : { adults: roomsInfo[0].adults, children: roomsInfo[0].children };
      const price = (isMobile && widgetData.rooms > 1) ? thn.parseNumber(el.nextElementSibling?.firstElementChild?.textContent) : thn.parseNumber(el.querySelector('.mainAmount')?.textContent);
      return {
        guests,
        price,
      };
    });

    // Prices
    const prices = roomsInfo.map((roomInfo) => {
      const totalGuests = {
        adults: roomInfo.adults,
        children: roomInfo.children,
      };
      const lowestPrices = getLowestPrice(totalGuests, rates);
      return lowestPrices;
    }).filter(Boolean);

    const sumPrice = prices.reduce((sum, number) => sum + (Number.isNaN(number) ? 0 : number), 0);
    const currency = thn.parseCurrency(document.querySelector('.mainAmount')?.textContent) || thn.parseUrlParameter('cur');
    const isRoomMatch = prices.length === widgetData.rooms;
    const noAvailability = !!document.querySelector('.AvailabilityInOtherDates') || !!(document.querySelector('.NotificationBanner') && !isRoomMatch);

    if (!thn.empty(sumPrice) && nights && currency && isRoomMatch) {
      widgetData.currency = currency;
      widgetData.price = sumPrice / nights;
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_170
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    const container = document.querySelector('.sb-booking-page');

    // If loading, observe
    if (container && !thn.simplebookingBookingObserver && document.querySelector('.spinner')) {
      // Create function to delete observer whenever we want
      const stop = function () {
        if (thn.simplebookingBookingObserver) {
          thn.stopObserveDom(container, thn.simplebookingBookingObserver);
          delete thn.simplebookingBookingObserver;
        }
      };

      thn.simplebookingBookingObserver = thn.debounce(function thnSimplebookingBookingObserver() {
        if (!document.querySelector('.spinner') && ctx.widget.setData().isSet()) {
          ctx.widget.save();
          stop();
        }
      }, 250);

      thn.observeDom(container, thn.simplebookingBookingObserver, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });

      thn.pageUnload(stop);
    }
  };

  engine.bookingParseData = function bookingParseData() {
    const widgetData = {};

    // Early exit: If the page is still loading, return nothing and avoid using PW data (widgetData.set)
    if (document.querySelector('.spinner')) {
      widgetData.set = false;
      return widgetData;
    }

    // VERSION 1: Booking confirmed
    // Dates
    const datesWrapper = document.querySelector('.sb-cart-head-dates');

    if (datesWrapper) {
      const dateSpans = datesWrapper.querySelectorAll('div span');
      const dateBegin = translateDate(dateSpans[0]?.textContent || '', thn.data.language || 'en');
      const dateEnd = translateDate(dateSpans[1]?.textContent || '', thn.data.language || 'en');

      if (dateBegin && dateEnd) {
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
      }
    }

    const detailsWrapper = document.querySelector('.sb-cart-head-nrg');

    if (detailsWrapper) {
      // Booking ID
      widgetData.bookingId = thn.parseNumber(document.querySelector('.reservation-code')?.textContent);

      // Nights and rooms
      const detailSpans = detailsWrapper.querySelectorAll('div span');
      widgetData.nights = thn.parseNumber(detailSpans[0]?.textContent);
      widgetData.rooms = thn.parseNumber(detailSpans[1]?.textContent);

      // Guests
      const guestsText = detailSpans[2]?.textContent.trim().split(' ');
      widgetData.adults = thn.parseNumber(guestsText[0]);
      widgetData.children = guestsText.length > 2 ? thn.parseNumber(guestsText[2]) : 0;
      widgetData.guests = widgetData.adults + widgetData.children;

      // Price and currency
      const priceWrapper = document.querySelector('.sb-total');
      if (priceWrapper) {
        const priceInt = priceWrapper.querySelector('.sb-int-part')?.textContent || '';
        const priceDec = priceWrapper.querySelector('.sb-dec-part')?.textContent || '';
        widgetData.price = thn.parseNumber(priceInt + priceDec);
        widgetData.currency = thn.parseCurrency(priceInt);
      }
    }

    // VERSION 3: Booking confirmed
    if (document.querySelector('.ReservationPublicPage')) {
      // Booking ID
      widgetData.bookingId = document.querySelector('.ActiveReservationInfos h5')?.textContent;
      // Dates
      const datesEl = document.querySelectorAll('.ReservationSummary__Summary > div:nth-child(1) > div > div');
      const dateBegin = [datesEl?.[0]?.children?.[0]?.textContent, datesEl?.[0]?.children?.[2]?.childNodes?.[0]?.textContent].join(' ');
      const dateEnd = [datesEl?.[1]?.children?.[0]?.textContent, datesEl?.[1]?.children?.[2]?.childNodes?.[0]?.textContent].join(' ');
      widgetData.dateBegin = translateDate(dateBegin, thn.data.language);
      widgetData.dateEnd = translateDate(dateEnd, thn.data.language);
      // Price and currency
      widgetData.price = thn.parseNumber(document.querySelector('.Prices .mainAmount').textContent);
      widgetData.currency = thn.parseCurrency(document.querySelector('.Prices .mainAmount').textContent);

    }

    // VERSION 2: Booking confirmed
    if (document.querySelector('.mdr-reserv-info-container')) {

      // Dates
      const checkin = document.querySelectorAll('#mdr-checkin span span'); // date format divided into each "span" tag with the following format "dom05set2021"
      const checkout = document.querySelectorAll('#mdr-checkout span span');

      if (checkin.length === 4 && checkout.length === 4) {
        widgetData.dateBegin = translateDate(`${checkin[0]?.textContent} ${checkin[1]?.textContent} ${checkin[2]?.textContent} ${checkin[3]?.textContent}`, thn.data.language);
        widgetData.dateEnd = translateDate(`${checkout[0]?.textContent} ${checkout[1]?.textContent} ${checkout[2]?.textContent} ${checkout[3]?.textContent}`, thn.data.language);
      }

      // Booking ID
      widgetData.bookingId = document.querySelector('.reservation-code')?.textContent;

      // Price and currency
      widgetData.price = thn.parseNumber(document.querySelector('.mdr-proposal-discounted-price')?.textContent);
      widgetData.currency = thn.parseCurrency(document.querySelector('.mdr-proposal-discounted-price')?.textContent);

    } else {
      const dataLayerPurchase = window.dataLayer && [...window.dataLayer].filter((search) => search[1] === 'purchase')[0]?.[2];

      // Dates
      const dateBeginFromUrl = thn.parseUrlParameter('in')?.replace(/-/g, '/');
      const dateEndFromUrl = thn.parseUrlParameter('out')?.replace(/-/g, '/');
      widgetData.dateBegin = dateBeginFromUrl;
      widgetData.dateEnd = dateEndFromUrl;

      // Booking ID
      const bookingId = document.querySelector('.ActiveReservationInfos h5')?.textContent;
      widgetData.bookingId = bookingId || dataLayerPurchase?.transaction_id;

      // Price and currency
      const priceText = Array.from(document.querySelectorAll('.Prices')).pop()?.textContent;
      widgetData.price = thn.parseNumber(priceText) || thn.parseNumber(dataLayerPurchase?.value);
      widgetData.currency = thn.parseCurrency(priceText) || dataLayerPurchase?.currency;
    }

    return widgetData;
  };

  return engine;
}

export { factory };
